module.exports = __webpack_public_path__ + "img/text.ee43b91e.png";